import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M7.75 16.25L16.25 7.75M16.25 16.25L7.75 7.75" vectorEffect="non-scaling-stroke" />
	</SVG>
);
